import { memo } from 'react';

import type { ClickableTextProps } from '@bitstopco/bitstop-theme';
import { truncateText } from '@bitstopco/bitstop-theme/helpers';

import TableColumnClickableText from '@/components/ui/table/TableColumnClickableText';

import { NOT_AVAILABLE } from '@/constants/app/config';

import type { Location } from '@/types';

interface TableColumnLocationProps {
  data: Location;
  link?: boolean;
  fixIcon?: ClickableTextProps['fixIcon'];
  truncate?: ClickableTextProps['truncate'];
}

const TableColumnLocation = ({ data, link, fixIcon, truncate }: TableColumnLocationProps) => {
  const id = String(data.location_id || NOT_AVAILABLE);
  const to = link ? `${window.location.origin}/location/${id}` : undefined;
  const text = data.location_name || NOT_AVAILABLE;
  const truncatedText = truncate ? truncateText(text, truncate) : text;

  return (
    <TableColumnClickableText
      id={id}
      to={to}
      text={truncatedText}
      fixIcon={fixIcon}
      clipboardValue={id}
      name="Location ID"
    />
  );
};

export default memo(TableColumnLocation);
